export const modelName = 'rates';

export const FETCH_PENDING = `${modelName}/FETCH_PENDING`;
export const FETCH_FAILED = `${modelName}/FETCH_FAILED`;
export const FETCH_SUCCESSED = `${modelName}/FETCH_SUCCESSED`;